module.exports = __webpack_public_path__ + "static/media/10.bbe9e56f.jpg";